import * as React from "react";
const SvgFiRrUserVisor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21 23a1 1 0 1 1-2 0c0-3.859-3.141-7-7-7s-7 3.141-7 7a1 1 0 1 1-2 0c0-4.963 4.037-9 9-9s9 4.037 9 9M5 6c0-.858.541-1.59 1.3-1.874A6.01 6.01 0 0 1 12 0a6.01 6.01 0 0 1 5.7 4.126 2.002 2.002 0 0 1 0 3.748A6.01 6.01 0 0 1 12 12a6.01 6.01 0 0 1-5.7-4.126A2 2 0 0 1 5 6m10.463 2H8.536a4 4 0 0 0 3.463 2 4 4 0 0 0 3.463-2zM8.536 4h6.927A4 4 0 0 0 12 2a4 4 0 0 0-3.464 2m8.099 17.573a7.3 7.3 0 0 0-1.132-1.887.534.534 0 0 0-.825.002 6.5 6.5 0 0 0-1.146 2.075 11.4 11.4 0 0 0-.414 1.818.364.364 0 0 0 .595.332c.532-.446 1.251-.97 1.726-.97.361 0 .785.205 1.15.462a.334.334 0 0 0 .518-.343 8 8 0 0 0-.472-1.489"
    />
  </svg>
);
export default SvgFiRrUserVisor;
